import { Grid, Typography } from '@mui/material';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { SarlaftTypePersonProps } from './props';
import { useSarlaftTypePerson } from './hook';
import { formatParams } from '../../../../../../shared/utils/params';

export const SarlaftTypePerson = (props: SarlaftTypePersonProps) => {
    const { formik, personTypes } = useSarlaftTypePerson(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Tipo de persona
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(personTypes)}
                    label="Tipo de persona"
                    name="typePerson"
                    size="small"
                    required
                    disabled
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typePerson}
                    errors={formik.errors.typePerson}
                    value={formik.values.typePerson}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typePerson', value)
                    }
                />
            </Grid>
        </Grid>
    );
};
